function cleanUUID(id = "", defaultResult = "S/I") {
  return id.slice(-6)?.toUpperCase() || defaultResult;
}

export default cleanUUID;
